export type SingleFlight = {
  isInFlight: () => boolean;
  run: <T, F = undefined>(
    action: () => Promise<T>,
    inFlightResult?: F,
  ) => Promise<T | F>;
};

export const createSingleFlight = (): SingleFlight => {
  let inFlight = false;

  return {
    isInFlight: () => inFlight,
    run: async <T, F = undefined>(
      action: () => Promise<T>,
      inFlightResult?: F,
    ): Promise<T | F> => {
      if (inFlight) {
        return inFlightResult as F;
      }

      inFlight = true;

      try {
        return await action();
      } finally {
        inFlight = false;
      }
    },
  };
};
